<template>
	<v-layout row>
		<v-btn :disabled="disabled" @click="timepicker = true"
			>{{ (label, 1) }} : {{ model | formatTime }}
			<v-icon @click.stop="remove" v-if="stringTime">close</v-icon>
		</v-btn>

		<v-time-picker
			persistent-hint
			:hint="hint"
			v-on-clickaway="closeTimePicker"
			:allowed-minutes="(val) => [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55].includes(val)"
			v-model="stringTime"
			v-if="timepicker"
			dark
			v-on:change="setDate()"
			class="fixed-error"
		></v-time-picker>

		<!-- handling error and validator -->
		<v-text-field v-model="model" class="custom-error" :rules="computedRules"></v-text-field>
	</v-layout>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	mixins: [clickaway],
	data() {
		return {
			stringTime: null,
			timepicker: false,
		}
	},
	methods: {
		remove() {
			this.stringTime = null
			this.model = null
			this.timepicker = false
			this.update()
		},
		closeTimePicker() {
			this.timepicker = false
		},
		setDate() {
			let date = new Date()
			date.setHours(this.stringTime.split(':')[0])
			date.setMinutes(this.stringTime.split(':')[1])
			this.model = date
			this.timepicker = false
			this.update()
		},
	},
}
</script>
<style lang="scss">
.bo-input .v-picker.fixed-error {
	position: absolute !important;
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/inputs/timeInput.vue